module.exports = __webpack_public_path__ + "img/sp_list.203d104b.png";